import { create } from 'zustand';

interface WsState {
  sendWsMessage: (payload: Record<string, unknown>) => void;
  setSendWsMessage: (fn: (payload: Record<string, unknown>) => void) => void;
  registerAckTimer: (clientMessageId: string, cancel: () => void) => void;
  setRegisterAckTimer: (fn: (clientMessageId: string, cancel: () => void) => void) => void;
}

export const useWsStore = create<WsState>()((set) => ({
  sendWsMessage: () => {},
  setSendWsMessage: (fn) => set({ sendWsMessage: fn }),
  registerAckTimer: () => {},
  setRegisterAckTimer: (fn) => set({ registerAckTimer: fn }),
}));
